export const createDuplicateName = ({ item, key = 'name' }) => ({ ...item, [key]: `${item[key]} - DUPLICATA` })
